import { Switch, Route, Redirect } from "react-router-dom";
import { useState, Suspense, lazy } from "react";

// Styles
import "./App.css";
import { Spin } from "antd";
import { getProjects } from "./helpers/apiCall";
import { WebSocketProvider } from "./helpers/websocketsContext";
import { TopBarProvider } from "./helpers/topBarContext";
// import "antd/dist/antd.min.css";

// Components
const Drawer = lazy(() => import("./components/SideBar"));
const TopBar = lazy(() => import("./components/TopBar"));

// Pages
const Upload = lazy(() => import("./pages/Upload"));
const Dashboard = lazy(() => import("./pages/Dashboard"));
const Results = lazy(() => import("./pages/Results"));
const Projects = lazy(() => import("./pages/Projects"));
const Extraction = lazy(() => import("./pages/Extraction"));
const About = lazy(() => import("./pages/About"));
const User = lazy(() => import("./pages/User"));
const SignUp = lazy(() => import("./pages/SignUp"));
const Map = lazy(() => import("./pages/Map"));
const Project = lazy(() => import("./pages/Project"));
const Task = lazy(() => import("./pages/Task"));
const NotFound = lazy(() => import("./pages/NotFound"));

// Libraries
const LoginPage = lazy(() => import("./pages/LoginPage"));

function App() {
  const [sideBarCollapsed, toggleSideBar] = useState(false);
  const [currentProject, setCurrentProject] = useState({});
  const [projects, setProjects] = useState([]);
  const [appKey, setAppKey] = useState(new Date());
  const accessToken = localStorage.getItem("token");
  const refreshToken = localStorage.getItem("refresh_token");

  const refreshProjects = () => {
    (accessToken || refreshToken) && getProjects().then(res => {
      const p = res?.data.map(e => ({ ...e, value: e.name }));
      setProjects(p || []);
    });
  }

  return (
    <div className="App" key={appKey}>
      <Switch>
        <Route
          path="/"
          exact
          render={() => (
            <Suspense fallback={<Spin />}>
              <LoginPage setAppKey={setAppKey} />
            </Suspense>
          )}
        />
        <Route
          path="/signup"
          render={() => (
            <Suspense fallback={<Spin />}>
              <SignUp />
            </Suspense>
          )}
        />
        {accessToken || refreshToken ? (
          <div className="dashboard">
            <WebSocketProvider>
              <TopBarProvider>
                <Suspense fallback={<Spin />}>
                  <Drawer
                    toggleSideBar={toggleSideBar}
                    sideBarCollapsed={sideBarCollapsed}
                    setCurrentProject={setCurrentProject}
                    projects={projects}
                    refreshProjects={refreshProjects}
                  />
                </Suspense>
                <Suspense fallback={<Spin />}>
                  <TopBar
                    sideBarCollapsed={sideBarCollapsed}
                    currentProject={currentProject}
                    setCurrentProject={setCurrentProject}
                  />
                </Suspense>
                <div
                  className="appHolder"
                  style={{
                    height: "100vh",
                    width: `calc(100vw - ${sideBarCollapsed ? 100 : 260}px)`,
                    float: "right",
                    overflow: "auto",
                  }}
                >
                  <Switch>
                    <Route
                      path="/about"
                      exact
                      render={() => (
                        <Suspense fallback={<Spin />}>
                          <About setCurrentProject={setCurrentProject} />
                        </Suspense>
                      )}
                    />
                    <Route
                      path="/dashboard"
                      render={() => (
                        <Suspense fallback={<Spin />}>
                          <Dashboard
                            setCurrentProject={setCurrentProject}
                            projects={projects}
                            refreshProjects={refreshProjects}
                          />
                        </Suspense>
                      )}
                    />
                    <Route
                      path="/screening"
                      render={() => (
                        <Suspense fallback={<Spin />}>
                          <Upload
                            currentProject={currentProject}
                            setCurrentProject={setCurrentProject}
                          />
                        </Suspense>
                      )}
                    />
                    <Route
                      path="/results"
                      render={() => (
                        <Suspense fallback={<Spin />}>
                          <Results />
                        </Suspense>
                      )}
                    />
                    <Route
                      path="/user"
                      render={() => (
                        <Suspense fallback={<Spin />}>
                          <User />
                        </Suspense>
                      )}
                    />
                    <Route
                      path="/project"
                      render={() => (
                        <Suspense fallback={<Spin />}>
                          <Project />
                        </Suspense>
                      )}
                    />
                    <Route
                      path="/task"
                      render={() => (
                        <Suspense fallback={<Spin />}>
                          <Task
                            currentProject={currentProject}
                            setCurrentProject={setCurrentProject}
                          />
                        </Suspense>
                      )}
                    />
                    <Route
                      path="/projects"
                      render={() => (
                        <Suspense fallback={<Spin />}>
                          <Projects />
                        </Suspense>
                      )}
                    />
                    <Route
                      path="/extraction"
                      render={() => (
                        <Suspense fallback={<Spin />}>
                          <Extraction />
                        </Suspense>
                      )}
                    />
                    <Route
                      path="/map"
                      render={() => (
                        <Suspense fallback={<Spin />}>
                          <Map />
                        </Suspense>
                      )}
                    />
                    <Route>
                      <Suspense fallback={<Spin />}>
                        <NotFound />
                      </Suspense>
                    </Route>
                  </Switch>
                </div>
              </TopBarProvider>
            </WebSocketProvider>
          </div>
        ) : (
          <Redirect to="/" />
        )}
      </Switch>
    </div>
  );
}

export default App;
